<wa-dialog
    data-testid="membership-inactive-dialog"
    label="Workspace access changed"
    [lightDismiss]="false"
    [open]="auth.membershipInactive()"
    (wa-hide)="onHide($event)">
    <p>Your access to this workspace changed. Please sign in again.</p>
    <wa-button data-testid="membership-inactive-signin-button" slot="footer" variant="brand" (click)="onSignIn()">Sign in again</wa-button>
</wa-dialog>
